import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { typography, colors, spacing } from '../../../../themes';

export const YearMonthPickerWrapper = styled.div`
  display: flex;
  flex-flow: column;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
`;

export const LabelContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.tiny};
`;

export const LabelWrapper = styled.div`
  display: flex;
  gap: ${spacing.tiny};
`;

export const PickerLabel = styled.label`
  ${typography.other.inputLabel};
  color: ${colors.primary.grey};
`;

export const RequiredIndicator = styled.div`
  color: ${colors.primary.grey};
`;

export const ErrorMessageBox = styled.div`
  height: 22px;
  ${typography.body.medium}
  color: ${colors.alerts.error};
  margin-top: ${spacing.tiny};
`;

export const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const DropdownPanel = styled.div`
  position: absolute;
  z-index: 100;
  top: calc(100% + 4px);
  right: 0;
  background-color: #fff;
  border: 1px solid #e6e6e6;
  box-shadow: 0px 15px 40px rgba(51, 51, 51, 0.15);
  border-radius: 4px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 272px;
`;

export const SectionTitle = styled.div`
  font-family: ${typography.fontFamily};
  font-size: 20px;
  font-weight: 500;
  line-height: 20px;
  color: ${colors.primary.grey};
  text-align: center;
  padding-bottom: 2px;
  border-bottom: 1px solid ${colors.monochrome.grey20};
`;

export const YearSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MonthPickerContainer = styled.div<{ withBorder?: boolean }>`
  max-width: calc(3 * (5rem + 4px));
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${({ withBorder }) =>
    withBorder &&
    css`
      border-top: 1px solid ${colors.monochrome.grey20};
      padding-top: 12px;
    `}

  .react-datepicker {
    padding: 0;
    border: none !important;
    box-shadow: none;
    max-width: 100%;
  }

  .react-datepicker__month-container {
    max-width: 100%;
  }

  .react-datepicker__header {
    padding: 0;
    border: none;
    display: none;
  }
`;

export const MultiYearMessage = styled.div`
  font-family: ${typography.fontFamily};
  ${typography.body.medium}
  color: ${colors.base.black};
  padding-top: 8px;
  border-top: 1px solid ${colors.monochrome.grey20};
`;
